import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

let timeCheckInterval
const timeCheckIntervalTimeout = 15
const minYOffset = 40

export default class HeroHeaderComponent extends Component {
  init() {
    this.buttonScroll = this.element.querySelector('.button--scroll')
    this.episodeCarousel = this.element.querySelector('#episodes')

    this.video = this.element.querySelector('video')
    this.video.addEventListener('error', () => {
      this.video.remove()
      this.video = null
    })
    this.video?.load()

    this.lastTargetTime = 0
    this.targetTime = 0
    this.startEpisodeId = window.location.hash.replace('#', '') || ''
    //this.hasScrolled = false

    window.addEventListener('video-mark-changed', event => this.onVideoMarkChanged(event))
    window.addEventListener('scroll', () => this.onScroll())
    this.buttonScroll?.addEventListener('click', event => this.onButtonScrollClick(event))
  }

  onVideoMarkChanged(event = {}) {
    if (!this.video || !event.detail) {
      return
    }

    this.lastTargetTime = this.targetTime - 0.01
    this.targetTime = parseFloat(event.detail)

    if (this.video.currentTime < this.lastTargetTime) {
      // This is so if you rapidly skip through the episodes, then it skips ahead to show the last part of the journey.
      this.video.pause()
      this.video.currentTime = this.lastTargetTime + 0.01
    }

    if (this.video.currentTime === this.targetTime) {
      return
    }

    //if (!this.hasScrolled) {
    //  this.video?.scrollIntoView({ behavior: 'smooth' })
    //}

    window.clearInterval(timeCheckInterval)
    timeCheckInterval = window.setInterval(() => {
      if (!this.video) {
        return
      }

      if (this.targetTime === this.lastTargetTime) {
        // Something weird happened, target time shouldn't be the same as last target time
        this.video.pause()
        this.video.currentTime = this.targetTime
      } else if (this.targetTime > this.lastTargetTime && this.video.currentTime < this.targetTime) {
        // Nothing on the hand, move on.
        this.video.play()
      } else if (this.targetTime < this.lastTargetTime && this.video.currentTime > this.targetTime) {
        // Reverse playback is too difficult so we just set the video time directly
        // Setting frames backwards results in dropped frames
        this.video.pause()
        this.video.currentTime = this.targetTime
        return
      }

      // This is when it arrived at the target time
      if (this.video.currentTime >= this.targetTime) {
        this.video.pause()
        this.video.currentTime = this.targetTime

        //if (!this.hasScrolled) {
        //  this.episodeCarousel?.scrollIntoView({ behavior: 'smooth' })
        //  this.hasScrolled = true
        //}
        window.clearInterval(timeCheckInterval)
      }
    }, timeCheckIntervalTimeout)
  }

  onButtonScrollClick(event = {}) {
    if (!this.buttonScroll || !this.episodeCarousel) {
      return
    }

    event.preventDefault()
    window.scrollTo({ top: this.episodeCarousel.offsetTop || 0, behavior: 'smooth' })
    this.buttonScroll.setAttribute('hidden', 'hidden')
  }

  onScroll() {
    if (window.pageYOffset > minYOffset) {
      this.buttonScroll?.setAttribute('hidden', 'hidden')
    } else {
      this.buttonScroll?.removeAttribute('hidden')
    }

    this.hasScrolled = true
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'hero-header', HeroHeaderComponent))
